const sortValuesProcesy = ['MPK', 'datumZaciatkuAktualnehoStadia', 'typPredpis', 'nazov'];
const sortValuesPredbezne = ['VYJADRENIA', 'datumZaciatkuAktualnehoStadia', 'nazov'];
const defaultSortProcesy = 'MPK';
const defaultSortPredbezne = 'VYJADRENIA';

export {
  sortValuesProcesy, defaultSortProcesy, sortValuesPredbezne, defaultSortPredbezne,
};
